/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var PubIcon = createIcon("PubIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#00887E';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47 30v-4.716h2.681c2.773 0 4.617-1.512 4.617-4.095 0-2.727-2.097-4.203-4.905-4.203H7.248V30H9.47Zm2.627-6.471H9.453v-4.815h2.582c1.521 0 2.655.855 2.655 2.349 0 1.467-1.07 2.466-2.591 2.466Zm11.755 6.651c3.59 0 5.012-1.845 5.012-4.932v-8.262h-2.213v8.361c0 2.034-1.09 2.952-2.8 2.952-1.7 0-2.753-.936-2.753-2.952v-8.361h-2.241v8.136c0 3.195 1.386 5.058 4.995 5.058Zm12.5-.18c3.448 0 5.068-1.134 5.068-3.51 0-1.332-.523-2.628-2.638-3.141 1.729-.675 2.323-1.629 2.323-2.961 0-2.196-1.63-3.402-4.932-3.402h-4.474V30h4.653Zm.19-7.47h-2.656v-3.807h2.457c1.548 0 2.646.639 2.646 1.944 0 1.368-1.25 1.863-2.447 1.863Zm-.163 5.724h-2.492v-3.951h2.654c1.504 0 2.656.639 2.656 2.007 0 1.26-.973 1.944-2.818 1.944Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.PubIcon",
  "replaceColor": true
});